// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","Link":"Link-4fnbn3334gsvmsmqw24yk9zbnzfk5uwyme187qyetp8vyq3sg61ew5umg41t4rwaw3n8bq789ms4fkwebxp6qp3d8bmk8sg1v65bd6u","loading":"loading-2c9j6t1h4ey99r3k3vcn3m2ds5yuekrruyqgr3qqrtwykrbs33fmg1jm2d8r32ajtjeqx5n72r4dumyusgm8aab9115k9zadab46kbh","pulse":"pulse-2c6eeut3e9bk3mmzvs6rckj6ss3mdwtpzd5s17xg6age6s34xnanm8n1cywas7ss5uq8gzm5sd7gcj9u8aexcdvkk9j3qcuyvtmwqg5"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/Link/Link.module.scss
// module id = 1788
// module chunks = 0